import { render } from "./ApplyCredit.vue?vue&type=template&id=64bbb144&scoped=true"
import script from "./ApplyCredit.vue?vue&type=script&lang=js"
export * from "./ApplyCredit.vue?vue&type=script&lang=js"

import "./ApplyCredit.vue?vue&type=style&index=0&id=64bbb144&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64bbb144"]])

export default __exports__